export const PASSAGE = [
  {
    id: "opening",
    text: "Light is the universe’s first medium. For millennia, creators have chased its essence across canvases, trying to trap its brilliance using pigment, glass, and shadow. But light has always refused to be held.",
    em: [{ p: "refused to be held" }],
  },
  { id: "turn", text: "Until now." },
  {
    id: "material",
    text: "You have discovered PrismPixel™. It is a completely transparent, waterborne coating—pure, zero-VOC, and effortlessly fool-proof. It can be applied to any transparent substrate, bonding seamlessly on a molecular level to become a conformal, invisible architecture. It does not simply cover the glass; it awakens it.",
    em: [{ p: "awakens it", gold: true }],
  },
  {
    id: "creation",
    text: "Rather than forcing you to paint the illusion of illumination, this elemental canvas delicately guides the innate behavior of photons. It grants you the unbridled power to build in pure luminescence. You can now compose with light itself, rendering it breathing, dimensional, and beautifully alive.",
    em: [{ p: "unbridled power", gold: true }, { p: "compose with light itself" }],
  },
  {
    id: "possibility",
    text: "This is not a mere tool to add to your studio; it is a threshold into an entirely new era of creation. It matters because the boundaries of what can be imagined—and physically built—have just dissolved.",
    em: [{ p: "entirely new era of creation", gold: true }, { p: "have just dissolved" }],
  },
  {
    id: "invitation",
    text: "We are opening the doors to a vanguard of artists, visionaries, and quiet rebels who have always sensed that light was meant to be shaped. If you are ready to create masterpieces from pure energy, using a medium as clean and essential as water, your moment has arrived.",
    em: [{ p: "your moment has arrived" }],
  },
];

export const PASSAGE_CLOSING = "The blank gallery waits. The light is ready.";
export const PASSAGE_QUESTION = "Will you step through?";
